export default function(value) {
    /**
     * Formats a phone number
     * Example: 1234567890 => 123-456-7890
     * @param {String} value
     * @return {String}
     */
    return value
        ? value
              .replace(/[^0-9]/g, '')
              .replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        : '-';
}
